import AbstractValidator from './AbstractValidator';

const patterns = [
    'AT(?:U[A-Z\\d]{8})',
    'BE(?:[0|1]{1}\\d{9})',
    'BG(?:\\d{9,10})',
    'CH(?:(E-|E|E\\s)([0-9]{3,3}(\\.)[0-9]{3,3}(\\.)[0-9]{3,3}|[0-9]{9,9})(\\s|)(MWST|TVA|IVA|))',
    'CY(?:\\d{8}[A-Z])',
    'CZ(?:\\d{8,10})',
    'DE(?:\\d{9})',
    'DK(?:(\\d{2} ?){3}\\d{2})',
    'EE(?:\\d{9})',
    'EL(?:\\d{9})',
    'ES(?:[A-Z]\\d{7}[A-Z]|\\d{8}[A-Z]|[A-Z]\\d{8})',
    'FI(?:\\d{8})',
    'FR(?:([A-Z0-9]{2})\\d{9})',
    'GB(?:\\d{9}|\\d{12}|(GD|HA)\\d{3})',
    'HR(?:\\d{11})',
    'HU(?:\\d{8})',
    'IE(?:[A-Z\\d]{8}|[A-Z\\d]{9})',
    'IT(?:\\d{11})',
    'LT(?:(\\d{9}|\\d{12}))',
    'LU(?:\\d{8})',
    'LV(?:\\d{11})',
    'MT(?:\\d{8})',
    'NL(?:\\d{9}B\\d{2})',
    'NO(?:\\d{9})',
    'PL(?:\\d{10})',
    'PT(?:\\d{9})',
    'RO(?:\\d{2,10})',
    'SE(?:\\d{12})',
    'SI(?:\\d{8})',
    'SK(?:\\d{10})',
];

export default class Vatin extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        notVatin: 'Die eingebenene Umsatzsteuer (%value%) ist nicht im richtigen Format.',
    };

    run()
    {
        if(!this.value.match(this.regex))
        {
            this.error = this.getMessage('notVatin');
        }
    }

    get regex()
    {
        return new RegExp(`^(${patterns.join('|')})$`);
    }
}